import { createReducer } from 'typesafe-actions'
import * as actions from 'redux/actions'
import { Action, UserState } from 'redux/reducers/interfaces'

const initialState: UserState = {
    isLoading: false,
    title: 'Профиль',
    subtitle: '',
    suppliers: [],
    isAdmin: false,
    token: ''
}

export const userReducer = createReducer<UserState, Action>(initialState)
    .handleAction(actions.loadUserInfo.request, (state) => ({
        ...state,
        isLoading: true
    }))
    .handleAction(actions.loadUserInfo.success, (state, action) => ({
        ...state,
        isLoading: false,
        subtitle: action.payload.subtitle,
        suppliers: action.payload.suppliers,
        isAdmin: action.payload.isAdmin,
        token: action.payload.token
    }))
    .handleAction(actions.loadUserInfo.failure, (state) => ({
        ...state,
        isLoading: false
    }))
